import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IUsuario } from '@appNeo/neoCore/interfaces/IUsuario';
import { UsuarioService } from '@appNeo/neoCore/services/usuario/usuario.service';
import { FormularioComponent } from '@appNeo/neoShared/components/formulario/formulario.component';
import { HistorialComponent } from '@appNeo/neoShared/components/historial/historial/historial.component';
import { NotificacionComponent } from '@appNeo/neoShared/components/notificacion/notificacion.component';
import { DialogActionEnum } from '@appNeo/neoShared/helpers/enums/DialogAction.enum';
import { FormatosFicherosEnum } from '@appNeo/neoShared/helpers/enums/FormatosFicheros.enum';

import { IconEnum } from '@appNeo/neoShared/helpers/enums/Icon.enum';
import { NotificacionEnum } from '@appNeo/neoShared/helpers/enums/Notificacion.enum';
import { ClasesPerfilAnchoEnum } from '@appNeo/neoShared/helpers/enums/perfil-propiedad-tag.enum';
import { IFicheroExtendido } from '@appNeo/neoShared/helpers/interfaces/IFichero';
import { ClasesFormularioAnchoEnum, IFormInput } from '@appNeo/neoShared/helpers/interfaces/IForm-input';
import { IPerfilPropiedad } from '@appNeo/neoShared/helpers/interfaces/IPerfilPropiedad';
import { FormularioService } from '@appNeo/neoShared/services/formulario/formulario.service';
import { environment } from '@environments/environment';
import { Subscription } from 'rxjs';
import { ITEMS_HISTORIAL } from '../../demo-componentes/demo-componentes-data';
import { ArbolPermisosComponent } from '../components/arbol-permisos/arbol-permisos.component';
import { DEMOARCHIVOS, TREE_DATA } from '../usuarios/layout-usuario-data';
import { CAMPOSFORMULARIO, PROPIEDADESPERFILUSUARIO } from './usuario-configuracion';

@Component({
  selector: 'neo-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.scss'],
  providers: [FormularioService]
})
export class UsuarioComponent implements OnInit, AfterViewInit, OnDestroy {

  urlPadrePrincipal: string = '/usuarios';
  codigo: string;
  usuario: IUsuario;
  subErrorApi: Subscription;
  subscriptionPermisoEdicion: Subscription;
  subEntidad: Subscription;
  subRequestFormulario: Subscription;
  cargando: boolean = true;
  grabando: boolean = false;
  /***************************************************************** */
  // configuracion necesaria para perfiles
  /***************************************************************** */
  propiedadesPerfilUsuario: IPerfilPropiedad[] = PROPIEDADESPERFILUSUARIO;
  
  /***************************************************************** */
  // configuracion necesaria para edicion
  /***************************************************************** */
  @ViewChild('notificacionPerfilFormularioEntidad') notificacionPerfilFormularioEntidad: NotificacionComponent;
  @ViewChild('formulario') formulario: FormularioComponent;
  camposFormulario: IFormInput[] = CAMPOSFORMULARIO;
    
  // COMPONENTESTE SECUNDARIOS
  @ViewChild('permisosUsuario') permisosUsuario: ArbolPermisosComponent;
  
  @ViewChild('historiaUsuario') historiaUsuario: HistorialComponent;
  items_historial: any;

  formatosPermitidos = [FormatosFicherosEnum.png, FormatosFicherosEnum.jpg, FormatosFicherosEnum.jpeg, FormatosFicherosEnum.pdf];;
  subidaMultiple= false;
  maximoElementosASubir= 10;
  tamanoMaximoTotal= 1000000000000000000;
  tamanoMaximoFichero = 200000000000000000;
  arrayArchivos: IFicheroExtendido[] = DEMOARCHIVOS;



  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public usuarioService: UsuarioService
  ) { 
    
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe ( ( paramMap ) => {
      if ( paramMap.has('id') && paramMap.get('id') ) {
        this.codigo = paramMap.get('id');
        this.route.data.subscribe(
          response => {
            this.usuario = response.usuario;
            // mapeo del objeto con la carga de todas las entidades relacionadas get(id)
            this.usuarioService.usuario = this.usuario;
            this.cargando = false;            
            this.subscriptionEntidad();
          }
        );
      } else {
        this.router.navigate([ environment.ruta_padre_admin_demo + this.urlPadrePrincipal ] );
      }
    });
  }

  ngOnDestroy(): void {

    if (this.subRequestFormulario) {
      this.subRequestFormulario.unsubscribe();
    }
    if (this.subEntidad){
      this.subEntidad.unsubscribe();
    }
    if (this.subErrorApi) {
      this.subErrorApi.unsubscribe();
    }
    // if (this.subscriptionPermisoEdicion) {
    //   this.subscriptionPermisoEdicion.unsubscribe();
    // }
  }

  ngAfterViewInit(): void {  
    this.cargarDatos();
    this.subscriptionErrorApi();    
  }


 subscriptionEntidad() {
    // documentacion propuesta activa
    this.subEntidad = this.usuarioService.usuario$.subscribe( usuario => {
      console.log(' SUB ENTIDAD SERVICIO ', usuario);
      if ( usuario ) {
        this.usuario = usuario;           
        // cargando datos del perfil usuario
        this.propiedadesPerfilUsuario.map(propiedad => propiedad.valor = (this.usuario.hasOwnProperty(propiedad.identificador)) ? this.usuario[propiedad.identificador] : '');
        // let propiedad_idProyectoTipo = this.auxiliarService.busquedaPropiedad(this.propiedadesPerfilUsuario, 'identificador', 'idProyectoTipo');
        // if (propiedad_idProyectoTipo) {
        //   propiedad_idProyectoTipo.valor = `${this.usuario.proyectoTipo.nombre}`;
        // }    
        this.cargarDatos();
      }
    });
  }

  cargarDatos() {
    // entidades relacionadas
    //  if (this.usuario?.requisitos && this.requisitosProyecto ) {
    if (this.permisosUsuario) {
      this.permisosUsuario.establecer(TREE_DATA);
    }  

    if (this.historiaUsuario) {
      this.historiaUsuario.establecerHistorial(ITEMS_HISTORIAL);
    }
  }


  onAccionContenedorCabeceraEntidad(evento) {
    if (evento.id === 'btn-editar') {
      this.editar();
    }

    if( evento.id === 'btn-cancelar-edicion') {
      this.notificacionPerfilFormularioEntidad.eliminarNotificaciones();
      this.usuarioService.editandoUsuario = false;
    }

    if (evento.id === 'btn-guardar') {
      this.grabando = true;
      let objeto = this.formulario.validaCampos( false );
      if (objeto &&  objeto.formulario && objeto.formulario.valid) {
        this.actualizar(objeto.valores);
      } else {
        this.grabando = false;
        this.showResult(`Debe rellenar los todos los campos obligatorios`, 'ko', DialogActionEnum.Create);
        return;
      }
    }
  }

  editar() {
    this.usuarioService.editandoUsuario = true;
  }

  // Enlace APi
  actualizar(parametrosRequest) {
    //  let parEntidad = [-- keys request a filtrar --- en caso de diferentes peticiones---];
    //  let parametrosEntidad: any = this.auxiliarService.filtrarParametros(parametrosRequest, parEntidad);
    // console.log('Actualizando...', parametrosRequest);
    // let _parametrosRequest = {...parametrosRequest, direccion: parametrosRequest.direccion.nombre};
    this.subRequestFormulario = this.usuarioService.update(this.usuario.id,parametrosRequest).subscribe({
      next: (v) => console.log(v),
      error: (e) =>  this.showResult(`Se ha producido un error en el proceso de actualización usuario. ${e}`, 'ko', DialogActionEnum.Update),
      complete: () => {this.showResult('Usuario actualizado con éxito!', 'ok', DialogActionEnum.Update); this.usuarioService.editandoUsuario = false;}
    });
  }

  showResult(message: string, status: string, dialogAction?: DialogActionEnum) {
    this.notificacionPerfilFormularioEntidad.eliminarNotificaciones();
    if (status === 'ok') {
      this.notificacionPerfilFormularioEntidad.crearNotificacion(NotificacionEnum.Exito, 'Operación correcta', message, false, IconEnum.Exito, '', true);
    } else {
      this.notificacionPerfilFormularioEntidad.crearNotificacion(NotificacionEnum.Error, 'Se ha producido un error en la edición del usuario', message, true, IconEnum.Error);
    }
    this.cargarDatos();
  }

  // HISTORIAL
  accionCrearItem(event){
    console.log('Crear el comentario ', event);
    let items = this.items_historial;
    items.push(event);

    this.historiaUsuario.establecerHistorial(items);
    this.historiaUsuario.mostrarResultado('ok');
  }

  // FICHEROS

  obtenerFicheros() {}


  eliminarFichero(ids){
    /*
    LA IDEA ES QUE A LA API PODREMOS MANDARLE UN ARRAY DE IDS PARA ELIMINAR VARIOS,
    MIENTRAS RECORRO EL ARRAY Y HAGO PETICIONES INDIVIDUALES, Y AL REALIZARLAS HAGO EL GET DE FICHEROS
    */
    for(let id of ids){
      console.log(id);
      this.usuarioService.eliminarFichero(id).subscribe(()=>{
        this.obtenerFicheros();
      });
    }
  }

  peticionCambiarPosicionEjemplo(nuevoArray){
    // AQUÍ HARÍAMOS PETICIÓN A LA API PARA EDITAR LOS ELEMENTOS
    console.log(nuevoArray);
  }

  subirFicheros(ficheros){
     // AQUÍ HARÍAMOS PETICIÓN A LA API PARA SUBIR NUEVOS ARCHIVOS
    //this.demoService.subirFichero(ficheros).subscribe( data => console.log('Respuesta subida ficheros ', data));
    this.obtenerFicheros();
   // this.testArrayArchivos = this.testArrayArchivosSubida;
  }

  preSubirFicheros(ficheros){
    // AQUÍ HARÍAMOS PETICIÓN A LA API PARA SUBIR NUEVOS ARCHIVOS
   this.usuarioService.subirFichero(ficheros).subscribe( data => console.log('Respuesta subida ficheros ', data));

  // this.testArrayArchivos = this.testArrayArchivosSubida;
 }

 eventoEditarFichero(datos){
   console.log('Edicion datos fichero ', datos);
 }

  
  /******************** */
  // subErrorProyecto
  subscriptionErrorApi() {
    this.subErrorApi = this.usuarioService.errorApi$.subscribe(data => {
      // if(this.requisitosProyecto)
      //   this.requisitosProyecto.errorApi = data;
    } );
  }

  get _ClasesFormularioAnchoEnum() {
    return ClasesFormularioAnchoEnum;
  }

  get _ClasesPerfilAnchoEnum() {
    return ClasesPerfilAnchoEnum;
  }

}
